import React, { useMemo, useRef, useState, useCallback } from "react";
import { HotKeys } from "react-hotkeys";

import LabelSelector, { compareLabels } from "../../containers/LabelSelector";
import type { Label, LabelSelection } from "../../containers/LabelSelector";

type LabelsContainerParams = {
  nextImageFunction: (ls: LabelSelection[], err: number[]) => void;
  addAndNextFunction?: (ls: LabelSelection[], err: number[]) => void;
  addOrRemoveFromCD?: () => void;
  currentLabel?: LabelSelection[];
  currentError?: number[];
  currentImageData?: any;
  labels: Label[];
  topDistance: number;
  nextButtonString: string;
  addAndNextButtonString?: string;
  hasMake100?: boolean;
};

const LabelsContainer = ({
  nextImageFunction,
  addAndNextFunction,
  addOrRemoveFromCD,
  currentLabel,
  currentError,
  currentImageData,
  labels,
  topDistance,
  nextButtonString,
  addAndNextButtonString,
  hasMake100,
}: LabelsContainerParams) => {
  const lsRef = useRef<React.ElementRef<typeof LabelSelector>>(null);
  const [resetLabels, setResetLabels] = useState(0);
  const [labelComplete, setLabelComplete] = useState(false);
  const [nextClicked, setNextClicked] = useState(false);

  const nextImage = () => {
    if (nextClicked) return;
    setNextClicked(true);

    if (lsRef.current.labelComplete()) {
      nextImageFunction(lsRef.current.selection(), lsRef.current.errors());
      setResetLabels(resetLabels + 1);
      setNextClicked(false);
    }
  };

  const addAndNext = () => {
    if (nextClicked) return;
    setNextClicked(true);

    if (lsRef.current.labelComplete()) {
      addAndNextFunction(lsRef.current.selection(), lsRef.current.errors());
      setNextClicked(false);
    }
  };

  const labelChangeCbk = useCallback(() => {
    setLabelComplete(lsRef.current.labelComplete());
  }, []);

  const errorChangeCbk = useCallback(() => {
    // console.log(lsRef.current.errors());
  }, []);

  const sortedLabels = useMemo(() => Object.values(labels).sort(compareLabels), [labels]);

  return (
    <HotKeys keyMap={{ nextImage: "alt+enter" }} handlers={{ nextImage: nextImage }}>
      <div
        style={{ top: `${topDistance}px`, padding: "2%" }}
        className="labelsContainerWindow"
        id="labelsContainerWindow"
      >
        <LabelSelector
          initialLabels={currentLabel}
          initialErrors={currentError}
          currentImageData={currentImageData}
          allLabels={sortedLabels}
          reset={resetLabels}
          labelChangeCbk={labelChangeCbk}
          errorChangeCbk={errorChangeCbk}
          hasMake100={hasMake100}
          ref={lsRef}
        />
        <input
          id="ToNextImage"
          disabled={!labelComplete}
          className="btn btn-primary backToNextImage"
          type="button"
          value={nextButtonString}
          onClick={nextImage}
        />
        {addAndNextFunction ? (
          <input
            id="AddToExamAndToNextImage"
            disabled={!labelComplete}
            className="btn btn-primary addAndNextImage"
            type="button"
            value={addAndNextButtonString}
            onClick={addAndNext}
          />
        ) : (
          ""
        )}
        {addOrRemoveFromCD && currentImageData?.viable_for_cd && (
          <input
            id="AddOrRemoveFromCD"
            className="btn btn-secondary addOrRemoveFromCD"
            type="button"
            value={currentImageData?.on_cd ? "Remove from CD" : "Approve for CD"}
            onClick={() => addOrRemoveFromCD()}
          />
        )}
      </div>
    </HotKeys>
  );
};

export default LabelsContainer;
